import { AddIcon, CheckIcon } from '@/components/Icons';
import { Paragraph } from '@/components/Paragraph';
import { StyledFlexColumn } from '@/layout/FlexLayout';
import { StyledButton } from '@/pages/TravelParty/styles';

import type { ItineraryTravelerType, ItineraryTraveler } from '@/types/travelers';

interface AddTravelPartyMemberButtonProps {
  number: number;
  type: ItineraryTravelerType;
  onClick: () => void;
}

const travelPartyMemberTypeToLabel: Record<ItineraryTravelerType, string> = {
  'Main Booker': 'Main Booker',
  'Fellow Traveler': 'Fellow Traveler',
};

export function AddTravelPartyMemberButton({ number, type, onClick }: AddTravelPartyMemberButtonProps) {
  return (
    <StyledButton onClick={onClick}>
      <AddIcon />
      <StyledFlexColumn>
        <Paragraph size="lg" weight={600}>
          {travelPartyMemberTypeToLabel[type]} {number}
        </Paragraph>
        <Paragraph color="tertiary">Add details of the {travelPartyMemberTypeToLabel[type]}</Paragraph>
      </StyledFlexColumn>
    </StyledButton>
  );
}

interface TravelPartyMemberButtonProps {
  traveler: ItineraryTraveler;
}

export function TravelPartyMemberButton({ traveler }: TravelPartyMemberButtonProps) {
  return (
    <StyledButton disabled>
      <CheckIcon />
      <StyledFlexColumn>
        <Paragraph size="lg" weight={600}>
          {traveler?.firstName} {traveler?.lastName}
        </Paragraph>
        <Paragraph color="tertiary">{travelPartyMemberTypeToLabel[traveler.type]}</Paragraph>
      </StyledFlexColumn>
    </StyledButton>
  );
}
